import { Box, Heading } from '@razorpay/blade/components';
import React from 'react';
import useFetchUserDetails from '../hooks/useFetchUserDetails';
import { useSearchParams } from 'hooks/useSearchParams';
import { useSelector } from 'react-redux';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';

export const Header = () => {
  const { urlParams } = useSearchParams();
  const userId = urlParams.get('userId');
  const loggedInUserId = useSelector(loggedInUserSelectors.peopleId);
  const peopleId = String(userId ?? loggedInUserId);
  const { firstName, isLoading } = useFetchUserDetails(peopleId);

  return (
    <Box display={'flex'} flexDirection={'row'} gap={'spacing.1'}>
      <Heading size="large" weight="semibold" color="surface.text.gray.normal" textAlign="center">
        {firstName ? `${firstName}'s Pay` : 'Pay'}
      </Heading>
      <Heading size="large" weight="regular" color="surface.text.gray.normal" textAlign="center">
        Details
      </Heading>
    </Box>
  );
};
